import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useContext, useState } from 'react';

import ExternalPolicyVerification from '@/components/PersonInsurancePolicy/ExternalPolicyVerification';
import { Color } from '@/constants/color';
import useNavigateToPage from '@/hooks/useNavigateToPage';
import PersonContext from '@/pages/Person/PersonContext';
import { ExternalPolicyVerification as ExternalPolicyType } from '@/types/externalVerification';
import Button from '@/ui/components/Button';

import { Props } from './types';

const DiscoveredPolicyVerifications = ({
  discoveredPolicyVerifications,
  insurancePolicyPriority,
  insuranceId
}: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const {
    person: { id: personId }
  } = useContext(PersonContext);

  const { navigateToNewInsuranceFromDiscovered } = useNavigateToPage();

  if (!discoveredPolicyVerifications || discoveredPolicyVerifications.length === 0) return null;

  const saveDiscoveredPolicyToNewPolicy = (policyVerification: ExternalPolicyType) => {
    navigateToNewInsuranceFromDiscovered(
      personId,
      policyVerification,
      insuranceId,
      insurancePolicyPriority
    );
  };

  return (
    <div className="my-2 flex flex-col gap-4">
      <Button
        ariaLabel={`See ${discoveredPolicyVerifications.length} discovered policies`}
        size="sm"
        color={Color.SLATE}
        onClick={() => setIsExpanded(!isExpanded)}>
        {isExpanded ? '' : 'See'} {discoveredPolicyVerifications.length} discovered policies
        <FontAwesomeIcon icon={isExpanded ? faChevronUp : faChevronDown} className="ml-2" />
      </Button>

      {isExpanded &&
        discoveredPolicyVerifications.map((policyVerification) => (
          <div
            key={policyVerification.id}
            className="flex flex-col border-solid border border-gray-200 rounded-lg p-2 gap-2">
            <ExternalPolicyVerification
              externalPolicyVerification={policyVerification}
              debugObject={policyVerification}
              isDiscovered={true}
            />
            <Button
              ariaLabel="Save to new policy"
              size="sm"
              color={Color.WHITE}
              onClick={() => saveDiscoveredPolicyToNewPolicy(policyVerification)}>
              Save to new policy
            </Button>
          </div>
        ))}
    </div>
  );
};
export default React.memo(DiscoveredPolicyVerifications);
